import { createFileRoute } from '@tanstack/react-router';
import { Page } from '@/components/Page';
import * as styles from './index.css';

export const Route = createFileRoute('/system/_auth/')({
    component: DashboardRoute,
});

function DashboardRoute() {
    return (
        <Page.Root>
            <Page.Content>
                <div className={styles.emptyState}>
                    <h1 className={styles.emptyStateTitle}>
                        現在、​ダッシュボードに​表示
                        <br />
                        できる​クライアント情報は​まだ​
                        <br />
                        ありません。​
                    </h1>
                    <p className={styles.emptyStateDescription}>
                        クライアントの​アカウント登録が​増えると、
                        <br />
                        ​この​ダッシュボードに、​あなたに​役立つ
                        <br />
                        情報が​表示されます。​
                    </p>
                    <div className={styles.underConstruction}>
                        <p>あなたのためだけのダッシュボード体験を準備中です！</p>
                    </div>
                </div>
            </Page.Content>
        </Page.Root>
    );
}
